import type { LeadTemperature } from "@ai-leasing-os/shared";
import { cn } from "@/lib/cn";

const LABEL: Record<LeadTemperature, string> = {
  cold: "Cold",
  warm: "Warm",
  hot: "Hot",
  very_hot: "Very hot",
};

const STYLE: Record<LeadTemperature, string> = {
  cold: "bg-cold-soft text-slate-700",
  warm: "bg-warm-soft text-amber-800",
  hot: "bg-hot-soft text-orange-800",
  very_hot: "bg-very_hot-soft text-red-700",
};

export function TemperaturePill({
  temperature,
  className,
}: {
  temperature: LeadTemperature;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide",
        STYLE[temperature],
        className,
      )}
    >
      {LABEL[temperature]}
    </span>
  );
}
